import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Информация о текущем пользователе
  getCurrentInfo () {
    return axios.get(`${i18n.locale}/api/public/user/current`)
  },
  // Проверка текущего пользователя
  checkUser () {
    return axios.get(`${i18n.locale}/api/public/user/current`)
  },
  // Получение действий по типам
  getActionPermissionsByType (type) {
    return axios.get(`${i18n.locale}/api/user/action/type/${type}`)
  },
  // Обновление данных у пользователя
  update (data) {
    return axios.post(`${i18n.locale}/api/user/update`, data)
  }
}
